// context/DrawerProvider/useDrawerState.ts
import { useSyncExternalStore } from 'react'
import { DrawerStore } from './DrawerStore'

function useDrawerSelector<T>(selector: (s: ReturnType<typeof DrawerStore.get>) => T): T {
  return useSyncExternalStore(DrawerStore.subscribe, () => selector(DrawerStore.get()))
}

export function useTaskDrawerOpen() {
  return useDrawerSelector(s => s.taskOpen)
}
export function useNcoDrawerOpen() {
  return useDrawerSelector(s => s.ncoOpen)
}
export function useMtbDrawerOpen() {
  return useDrawerSelector(s => s.mtbOpen)
}
export function useAccountingDrawerOpen() {
  return useDrawerSelector(s => s.accountingOpen)
}
export function useProjectDrawerOpen() {
  return useDrawerSelector(s => s.projectOpen)
}
